import useSWR from 'swr';
import useSWRInfinite, { SWRInfiniteKeyLoader } from 'swr/infinite';

interface Props {
  ascent: Ascent;
  isLoading: boolean;
  isError: boolean;
  mutate: any;
}

export const useAscent = (id: string | string[]): Props => {
  const { data, error, isLoading, mutate } = useSWR(id && `/api/ascents/${id}`);
  return {
    ascent: data,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useAscents = (pageIndex, pageSize) => {
  const getKey: SWRInfiniteKeyLoader = (index, previousPageData) => {
    if (previousPageData && !previousPageData.length) return null;
    return `/api/ascents?pageIndex=${pageIndex}&pageSize=${pageSize}`;
  };

  const { data, error, isLoading, isValidating, mutate, size, setSize } =
    useSWRInfinite(getKey);

  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
    size,
    setSize,
  };
};

export const useMediaAscents = (pageIndex, pageSize) => {
  const getKey: SWRInfiniteKeyLoader = (index, previousPageData) => {
    if (previousPageData && !previousPageData.length) return null;
    return `/api/ascents/videos?pageIndex=${pageIndex}&pageSize=${pageSize}`;
  };

  const { data, error, isLoading, isValidating, mutate, size, setSize } =
    useSWRInfinite(getKey);

  return {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
    size,
    setSize,
  };
};

export const useUserGrades = (username: string, discipline: string) => {
  const { data, error, isLoading, mutate } = useSWR(
    `/api/users/${username}/${discipline}/grade`,
  );
  return {
    grades: data,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useUserYears = (username: string, discipline: string) => {
  const { data, error, isLoading, mutate } = useSWR(
    `/api/users/${username}/${discipline}/year`,
  );
  return {
    years: data,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useUserAscents = (
  username: string | string[],
  discipline: string | string[],
  pageSize: number,
  // pageIndex: number,
) => {
  const getKey: SWRInfiniteKeyLoader = (pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData.length) return null; // reached the end
    return `/api/users/${username}/${discipline}?pageSize=${pageSize}&pageIndex=${pageIndex}`;
  };

  const { data, error, size, setSize, isValidating } = useSWRInfinite(getKey);

  return {
    ascents: data ? [].concat(...data) : [],
    size,
    setSize,
    isLoadingInitialData: !data && !error,
    isLoadingMore:
      (!data && !error) ||
      (size > 0 && data && typeof data[size - 1] === 'undefined'),
    isEmpty: data?.[0]?.length === 0,
    isReachingEnd: size === pageSize,
    isRefreshing: isValidating && data && data.length === size,
  };
};
